/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiDeviceFromJSON(json) {
    return StreemApiDeviceFromJSONTyped(json, false);
}
export function StreemApiDeviceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'appSid': !exists(json, 'app_sid') ? undefined : json['app_sid'],
        'apiLevel': !exists(json, 'api_level') ? undefined : json['api_level'],
        'applicationName': !exists(json, 'application_name') ? undefined : json['application_name'],
        'appVersion': !exists(json, 'app_version') ? undefined : json['app_version'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'buildNumber': !exists(json, 'build_number') ? undefined : json['build_number'],
        'bundleId': !exists(json, 'bundle_id') ? undefined : json['bundle_id'],
        'deviceCountry': !exists(json, 'device_country') ? undefined : json['device_country'],
        'deviceLocale': !exists(json, 'device_locale') ? undefined : json['device_locale'],
        'deviceName': !exists(json, 'device_name') ? undefined : json['device_name'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'maxMemory': !exists(json, 'max_memory') ? undefined : json['max_memory'],
        'model': !exists(json, 'model') ? undefined : json['model'],
        'modelCode': !exists(json, 'model_code') ? undefined : json['model_code'],
        'platform': !exists(json, 'platform') ? undefined : json['platform'],
        'systemName': !exists(json, 'system_name') ? undefined : json['system_name'],
        'systemVersion': !exists(json, 'system_version') ? undefined : json['system_version'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'totalMemory': !exists(json, 'total_memory') ? undefined : json['total_memory'],
        'userAgent': !exists(json, 'user_agent') ? undefined : json['user_agent'],
        'vendorId': !exists(json, 'vendor_id') ? undefined : json['vendor_id'],
        'supportedVideoCodecs': !exists(json, 'supported_video_codecs') ? undefined : json['supported_video_codecs'],
        'supportedVideoPlatforms': !exists(json, 'supported_video_platforms') ? undefined : json['supported_video_platforms'],
        'supportedWallPlatforms': !exists(json, 'supported_wall_platforms') ? undefined : json['supported_wall_platforms'],
        'sdkVersion': !exists(json, 'sdk_version') ? undefined : json['sdk_version'],
        'sdkType': !exists(json, 'sdk_type') ? undefined : json['sdk_type'],
        'buildId': !exists(json, 'build_id') ? undefined : json['build_id'],
    };
}
export function StreemApiDeviceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'app_sid': value.appSid,
        'api_level': value.apiLevel,
        'application_name': value.applicationName,
        'app_version': value.appVersion,
        'brand': value.brand,
        'build_number': value.buildNumber,
        'bundle_id': value.bundleId,
        'device_country': value.deviceCountry,
        'device_locale': value.deviceLocale,
        'device_name': value.deviceName,
        'manufacturer': value.manufacturer,
        'max_memory': value.maxMemory,
        'model': value.model,
        'model_code': value.modelCode,
        'platform': value.platform,
        'system_name': value.systemName,
        'system_version': value.systemVersion,
        'timezone': value.timezone,
        'total_memory': value.totalMemory,
        'user_agent': value.userAgent,
        'vendor_id': value.vendorId,
        'supported_video_codecs': value.supportedVideoCodecs,
        'supported_video_platforms': value.supportedVideoPlatforms,
        'supported_wall_platforms': value.supportedWallPlatforms,
        'sdk_version': value.sdkVersion,
        'sdk_type': value.sdkType,
        'build_id': value.buildId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiDeviceSupportedVideoCodecs;
(function (StreemApiDeviceSupportedVideoCodecs) {
    StreemApiDeviceSupportedVideoCodecs["H264"] = "VIDEO_CODEC_H264";
    StreemApiDeviceSupportedVideoCodecs["INVALID"] = "VIDEO_CODEC_INVALID";
    StreemApiDeviceSupportedVideoCodecs["VP8"] = "VIDEO_CODEC_VP8";
    StreemApiDeviceSupportedVideoCodecs["VP9"] = "VIDEO_CODEC_VP9";
})(StreemApiDeviceSupportedVideoCodecs || (StreemApiDeviceSupportedVideoCodecs = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiDeviceSupportedVideoPlatforms;
(function (StreemApiDeviceSupportedVideoPlatforms) {
    StreemApiDeviceSupportedVideoPlatforms["ARAAS"] = "VIDEO_PLATFORM_ARAAS";
    StreemApiDeviceSupportedVideoPlatforms["CHIME"] = "VIDEO_PLATFORM_CHIME";
    StreemApiDeviceSupportedVideoPlatforms["INVALID"] = "VIDEO_PLATFORM_INVALID";
    StreemApiDeviceSupportedVideoPlatforms["TWILIO"] = "VIDEO_PLATFORM_TWILIO";
})(StreemApiDeviceSupportedVideoPlatforms || (StreemApiDeviceSupportedVideoPlatforms = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiDeviceSupportedWallPlatforms;
(function (StreemApiDeviceSupportedWallPlatforms) {
    StreemApiDeviceSupportedWallPlatforms["STREEM"] = "WALL_PLATFORM_STREEM";
    StreemApiDeviceSupportedWallPlatforms["TWILIO"] = "WALL_PLATFORM_TWILIO";
    StreemApiDeviceSupportedWallPlatforms["INVALID"] = "WALL_PLATFORM_INVALID";
})(StreemApiDeviceSupportedWallPlatforms || (StreemApiDeviceSupportedWallPlatforms = {}));
//# sourceMappingURL=StreemApiDevice.js.map